"use strict";

var React = require('react'),
    ReactRouter = require('react-router'),
    BS = require('react-bootstrap'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    CurrentUser = require('../../shared/CurrentUser'),
    UserForgot = require('../../models/UserForgot'),
    Constants = require('../../constants'),
    Cmp = require('../../components'),
    Link = require('../../components/Link'),
    Validation = require('../../partials/validation'),
    Footer = require('./Footer'),
    URI = require('urijs');

var ForgotPassword = React.createClass({displayName: "ForgotPassword",
    mixins: [
        ReactRouter.Navigation
    ],

    contextTypes: {
        router: React.PropTypes.func
    },

    getDefaultProps: function() {
        return {
            model: new UserForgot()
        };
    },

    updateState: function() {
        return {
            success: false
        };
    },

    getInitialState: function() {
        return this.updateState();
    },

    componentWillMount: function() {
        this.props.model.clear();
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            usernameIcon = (
                React.createElement("i", {className: "fa fa-user fa-fw"})
            ), 
            emailIcon = (
                React.createElement("i", {className: "fa fa-envelope fa-fw"})
            ),
            title = props.title + ' - Forgot Password';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                 React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-6 col-sm-offset-3"}, 
                            React.createElement(BS.Panel, {className: "panel-split-header", header: (React.createElement("h2", null, "Recover Password ", React.createElement("span", null, "or"), " ", React.createElement(Link, {to: "Login", className: "blue-text"}, "Login")))}, 
                                state.success && (
                                    React.createElement(BS.Alert, {bsStyle: "success"}, 
                                        "Password reset email sent. Please check your email and click on the link within to reset your password."
                                    )
                                ), 
                                React.createElement(Validation.Form, {horizontal: false, ref: "form", model: props.model, onSubmit: me.onSubmit, success: state.success, getMessage: me.getMessage, validateOnLoad: false}, 
                                    React.createElement(Validation.Input, {trigger: "onChange", addonBefore: emailIcon, type: "text", placeholder: "Email Address", name: "email"}), 
                                    React.createElement(Cmp.Button.Save, {className: "btn-block"}, "Submit")
                                )
                            ), 
                            React.createElement(Footer, {trackerId: "agent-toolbox-forgot"})
                        )
                    )
                )
            )
        );
    },

    onSubmit: function(e) {
        var me = this,
            state = me.state,
            props = me.props;

        if (me.refs.form.isValid()) {
            props.model.resetPassword(me.refs.form.getValues()).then(function() {
                me.setState({
                    success: true
                });
            });
        }
    },

    getMessage: function(type, model_collection, response, options) {
        return 'Error. Please try again.';
    }
});
module.exports = ForgotPassword;
